<template>
  <div class="cardBox">
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true" v-show="showSearch" label-width="68px">
      <el-form-item label="位置" prop="id">
        <el-select
            v-model="queryParams.id"
            placeholder="请选择位置"
            clearable
            style="width: 200px">
          <el-option
              v-for="dict in videoDateList"
              :key="dict.id"
              :label="dict.videoName"
              :value="dict.id"/>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="Search" @click="handleQuery()">搜索</el-button>
      </el-form-item>
    </el-form>
    <div class="cardBox">
      <iframe
          style="width: 100%; height: 100%"
          :src="url"
          frameborder="no"></iframe>
    </div>
  </div>

</template>

<script>
import {getVideoDate, listVideoDate} from "@/api/videoDate/videoDate"

export default {
  name: "videoDate",
  data() {
    return {
      queryParams: {
        id: null,
        videoName: null,
        videoUrl: null,
        tokenDate: null
      },
      videoDate: {},
      showSearch: true,
      videoDateList: [],
      url: "",
    }
  },
  created() {
    this.getList();
  },
  methods: {
    getList() {
      listVideoDate().then(res => {
        this.videoDateList = res.body.data
        this.videoDateList.forEach(res=>{
          this.url = "https://open.ys7.com/ezopen/h5/iframe?url="+res.videoUrl + "&accessToken=" + res.tokenDate
        })
        this.total = res.body.cum
      })
    },
    getVideoDateById(){
      if (this.queryParams.id === null){
        this.queryParams.id = 0
      }
      getVideoDate(this.queryParams.id).then(res => {
        this.url = "https://open.ys7.com/ezopen/h5/iframe?url=" +res.body.data.videoUrl + "&accessToken=" + res.body.data.tokenDate
      })
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.getVideoDateById();
    }
  }
}
</script>

<style scoped>
.cardBox {
  width: 90%;
  height: 770px;
  margin-bottom: 10px;
  background: white;
}
</style>